import { createContext, useContext } from 'react';

export type OnErrorMeta = { isPageLoadError: boolean };

export type AxiosHookConfig = {
  onError?: ((error: unknown, meta: OnErrorMeta) => void) | null;
  cache: Record<string, Promise<unknown> | unknown>;
};

const AxiosHookConfigContext = createContext<AxiosHookConfig>({
  cache: {},
});

export function useAxiosHookConfig() {
  return useContext(AxiosHookConfigContext);
}

export const AxiosHookConfigProvider = AxiosHookConfigContext.Provider;
